<template>
    <v-container fluid class="px-0 mx-0">
        <v-row>
            <v-col cols="12">
                <v-chip-group
                    v-model="option"
                    column
                    mandatory
                >
                    <v-chip
                        v-for="item in [match.team1, match.team2]"
                        :key="`${item.id}-${item.name}`"
                        filter
                        filter-icon="mdi-basketball-hoop"
                        active-class="selected-chip custom-teal"
                        color="white"
                        large
                        mandatory
                        class="text-h5 font-weight-bold"
                    >
                        {{ item.name }}
                    </v-chip>
                </v-chip-group>
            </v-col>
            <v-col cols="12" class="px-0 mx-0">
                <template>
                    <v-data-table
                        :headers="headers"
                        :items="tableItems"
                        class="elevation-1 py-3 px-3 text-center"
                        style="background: #232323;"
                        dark
                        hide-default-footer
                        :mobile-breakpoint="0"
                        :items-per-page="-1"
                        item-key="id"
                    >
                        <template v-slot:item.player="{ item }">
                            <span class="font-weight-bold">{{ item.player }}</span>
                        </template>

                        <template v-slot:item.points="{ item }">
                            <span class="font-weight-bold">{{ item.points }}</span>
                        </template>

                        <template v-slot:item.two_points_percentage="{ item }">
                            <span class="font-weight-bold">
                                {{ `${item.two_points_percentage.toFixed(1)}% (${item.twoMade} / ${item.twoAtt})` }}
                            </span>
                        </template>

                        <template v-slot:item.three_points_percentage="{ item }">
                            <span class="font-weight-bold">
                                {{ `${item.three_points_percentage.toFixed(1)}% (${item.threeMade} / ${item.threeAtt})` }}
                            </span>
                        </template>

                        <template v-slot:item.free_throw_percentage="{ item }">
                            <span class="font-weight-bold">
                                {{ `${item.free_throw_percentage.toFixed(1)}% (${item.ftMade} / ${item.ftAtt})` }}
                            </span>
                        </template>
                        <template v-slot:item.offensiveRebounds="{ item }">
                            <span class="font-weight-bold"> {{ item.stats[0]?.offensiveRebounds }} </span>
                        </template>
                        <template v-slot:item.defensiveRebounds="{ item }">
                            <span class="font-weight-bold"> {{ item.stats[0]?.defensiveRebounds }} </span>
                        </template>
                        <template v-slot:item.rebounds="{ item }">
                            <span class="font-weight-bold"> {{ item.stats[0]?.rebounds }} </span>
                        </template>
                        <template v-slot:item.assists="{ item }">
                            <span class="font-weight-bold"> {{ item.stats[0]?.assists }} </span>
                        </template>
                        <template v-slot:item.steals="{ item }">
                            <span class="font-weight-bold"> {{ item.stats[0]?.steals }} </span>
                        </template>
                        <template v-slot:item.turnovers="{ item }">
                            <span class="font-weight-bold"> {{ item.stats[0]?.turnovers }} </span>
                        </template>
                        <template v-slot:item.blockedShots="{ item }">
                            <span class="font-weight-bold"> {{ item.stats[0]?.blockedShots }} </span>
                        </template>
                        <template v-slot:item.personalFouls="{ item }">
                            <span class="font-weight-bold"> {{ item.stats[0]?.personalFouls }} </span>
                        </template>
                        <template v-slot:item.pir="{ item }">
                            <span class="font-weight-bold"> {{ item.stats[0]?.pir }} </span>
                        </template>
                        <!-- <template v-slot:item.playTimeInSecs="{ item }">
                            <span class="font-weight-bold">
                                {{ secToMinutesSeconds(item.stats[0]?.playTimeInSecs) }}
                            </span>
                        </template> -->
                    </v-data-table>
                </template>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            id: {
                type: Number,
                default: null
            },
            match: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                option: 0,
                team: 'Veterans BC',
                year: '2022-2023',
                phase: 'Regular Season',
                round: 'Round 1',
                headers: [
                    { text: 'Player', value: 'player', width: '200px', align: 'start' },
                    {
                        text: '# Number',
                        align: 'center',
                        value: 'jersey',
                        width: '50px'
                    },
                    { text: 'Pts', value: 'points', align: 'center' },
                    { text: '2P%', value: 'two_points_percentage', width: '170px', align: 'center' },
                    { text: '3P%', value: 'three_points_percentage', width: '170px', align: 'center' },
                    { text: 'FT%', value: 'free_throw_percentage', width: '170px', align: 'center' },
                    { text: 'OR', value: 'offensiveRebounds', align: 'center' },
                    { text: 'DR', value: 'defensiveRebounds', align: 'center' },
                    { text: 'TR', value: 'rebounds', align: 'center' },
                    { text: 'AST', value: 'assists', align: 'center' },
                    { text: 'STL', value: 'steals', align: 'center' },
                    { text: 'TO', value: 'turnovers', align: 'center' },
                    { text: 'BLK', value: 'blockedShots', align: 'center' },
                    { text: 'FC', value: 'personalFouls', align: 'center' },
                    { text: 'EFF', value: 'pir', align: 'center' }
                    // { text: 'Min', value: 'playTimeInSecs', align: 'center' }
                ]
            }
        },
        computed: {
            tableItems() {
                const src = this.getPlayers() || []
                return src.map(p => {
                    const s = (p.stats && p.stats[0]) || {}
                    const twoMade = Number(s.twoPointsMade) || 0
                    const twoAtt = Number(s.twoPointAttempts) || 0
                    const threeMade = Number(s.threePointsMade) || 0
                    const threeAtt = Number(s.threePointAttempts) || 0
                    const ftMade = Number(s.freeThrowsMade) || 0
                    const ftAtt = Number(s.freeThrowAttempts) || 0

                    return {
                        ...p,
                        // values used by sorting
                        player: p.number ? (p.player || `${p.name || ''} ${p.surname || ''}`.trim())
                            : `${p.name || ''} ${p.surname || ''}`.trim(),
                        points: Number(s.points) || 0,
                        two_points_percentage: twoAtt ? (twoMade / twoAtt) * 100 : 0,
                        three_points_percentage: threeAtt ? (threeMade / threeAtt) * 100 : 0,
                        free_throw_percentage: ftAtt ? (ftMade / ftAtt) * 100 : 0,
                        offensiveRebounds: Number(s.offensiveRebounds) || 0,
                        defensiveRebounds: Number(s.defensiveRebounds) || 0,
                        rebounds: Number(s.rebounds) || 0,
                        assists: Number(s.assists) || 0,
                        steals: Number(s.steals) || 0,
                        turnovers: Number(s.turnovers) || 0,
                        blockedShots: Number(s.blockedShots) || 0,
                        personalFouls: Number(s.personalFouls) || 0,
                        pir: Number(s.pir) || 0,
                        playTimeInSecs: Number(s.playTimeInSecs) || 0,

                        // extras for display in slots
                        twoMade,
                        twoAtt,
                        threeMade,
                        threeAtt,
                        ftMade,
                        ftAtt
                    }
                })
            }
        },
        created() {
        },
        methods: {
            getPlayers() {
                if (this.option) {
                    return this.match.team2.players.filter((player) => player.active).sort((a, b) => {
                        return a.jersey < b.jersey ? -1 : 1
                    })
                } else {
                    return this.match.team1.players.filter((player) => player.active).sort((a, b) => {
                        return a.jersey < b.jersey ? -1 : 1
                    })
                }
            },
            secToMinutesSeconds(secs) {
                if (secs < 0) return '-'
                if (typeof secs !== 'number' || isNaN(secs)) return '-'
                const minutes = Math.floor(secs / 60)
                const seconds = Math.floor(secs % 60)
                if (isNaN(minutes) || isNaN(seconds)) return '-'
                return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
            }
        }
    }
</script>

<style scoped>
.text-h5 {
    font-size: 1.5rem !important;
    font-weight: 400;
    letter-spacing: normal !important;
    font-family: Arial, sans-serif !important;
}

.v-chip::before {
    background-color: white !important;
}

.selected-chip {
    color: white;
}
</style>
